// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"588":"lastViewed","824":"csrf"}[chunkId] + ".bundle.js";
};